export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505]">
    <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 sm:px-10">
      <div className="flex flex-col gap-10 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-[#F3F3F5]">
            JW. EDITS
          </p>
          <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.3em] text-[#8E8E93]">
            REAL-LIFE VIDEO EDITING
          </p>
          <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.3em] text-[#3a3a3f]">
            EST. 2026 — JEREMIAH WOMACK
          </p>
        </div>
        <div className="flex gap-8">
          <a
            data-testid="footer-instagram-link"
            href="https://www.instagram.com/j.erem1ah/"
            target="_blank"
            rel="noopener noreferrer"
            className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8E8E93] transition-colors hover:text-[#E63946]"
          >
            INSTAGRAM
          </a>
          <a
            data-testid="footer-email-link"
            href="mailto:hello@jwedits.com"
            className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8E8E93] transition-colors hover:text-[#E63946]"
          >
            EMAIL
          </a>
          <a
            data-testid="footer-main-site-link"
            href="https://jeremiahwomack.com"
            target="_blank"
            rel="noopener noreferrer"
            className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8E8E93] transition-colors hover:text-[#E63946]"
          >
            JEREMIAHWOMACK.COM
          </a>
        </div>
      </div>
    </div>
    <div aria-hidden="true" className="select-none overflow-hidden">
      <p className="translate-y-[12%] text-center font-display text-[19vw] font-black uppercase leading-[0.8] tracking-tight text-white/[0.04]">
        JW. EDITS
      </p>
    </div>
  </footer>
);
